import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../node_modules/postcss-loader/dist/cjs.js??ref--6-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/dist/cjs.js??ref--6-4!../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--9-0!../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../node_modules/postcss-loader/dist/cjs.js??ref--9-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/dist/cjs.js??ref--9-4!./main.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};